module.exports = __webpack_public_path__ + "img/service-3.b0345b1e.png";